import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
const vue = new Vue()
const state = {
  buttonList: []
}
const actions = {
// 获取列表
  [types.GETMENULIST] (context) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/OfficeButton/getButtonList').then(data => {
        context.commit(types.GETMENULIST, data)
        resolve(data.obj)
      })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 更新
  [types.UPDATEBUTTON] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/OfficeButton/updateButton', params).then(data => {
        if (data.success) {
          // context.dispatch(types.GETMENULIST)
          resolve(data)
        }
        context.commit(types.UPDATEBUTTON, data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除
  [types.DELETEBUTTON] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/OfficeButton/deleteById', params).then(data => {
        if (data.success) {
          context.dispatch(types.GETMENULIST)
          resolve(data)
        }
        context.commit(types.DELETEBUTTON, data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 刷新应用
  [types.APPLYBUTTON] (context) {
    http.fetch('/api/OfficeButton/applyButton').then(data => {
      context.commit(types.APPLYBUTTON, data)
    })
  }
}
const mutations = {
// 获取列表
  [types.GETMENULIST] (state, data) {
    state.buttonList = data.obj
  },
  // 更新
  [types.UPDATEBUTTON] (state, data) {
    if (data.success) {
      vue.$message({
        showClose: true,
        message: '更新成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
    }
  },
  // 删除
  [types.DELETEBUTTON] (state, data) {
    if (data.code !== 200) return
    vue.$message({
      showClose: true,
      message: '删除成功',
      type: 'success'
    })
  },
  // 刷新应用
  [types.APPLYBUTTON] (state, data) {
    if (data.code !== 200) return
    vue.$message({
      showClose: true,
      message: '刷新应用成功',
      type: 'success'
    })
  }
}
export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/officeButtonManage/index.js